<template>
  <!-- Modal -->
  <div class="modal fade" id="ArchiveInventoryNoteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title">{{ translations('inventory.remarks') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body pb-0 pt-3">
          <v-textarea rows="1" auto-grow outlined label="" id="comment" v-model="tempDetail.note" />
        </div>
        <div class="modal-footer">
          <button ref="closeUpdateInventory" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>
          <button type="button" class="btn btn-primary" @click="updateNoteInventory()">{{ translations('common.keep') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveInventoryNoteModal',
  components: {
    VueElementLoading
  },
  props: {
    detail: {},
    originalDetail: {},
    inventory_at: null,
    selectedCondition: null
  },
  data () {
    return {
      tempDetail: {},
      isSearching: false,
      placeholder: '備考'
    }
  },
  watch: {
    originalDetail: {
      handler: function (data, oldData) {
        this.tempDetail = data
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    clearTempDetail: function () {
      this.tempDetail = {}
    },

    async updateNoteInventory () {
      if (this.tempDetail.note.length > 500) {
        this.$toastr.error('500文字数を超えています。')
        return
      }
      this.isSearching = true
      try {
        const params = {
          condition: this.selectedCondition,
          history_id: this.tempDetail.history_id,
          note: this.tempDetail.note
        }
        const responseNote = await this.$http.post(this.$api_url.inventory_note, params)
        if (responseNote.data.status) {
          this.$toastr.success('メモは正常に変更されました。', 'Success')
          this.updateTable()
        } else {
          this.$toastr.error(responseNote.data.message, 'エラー')
        }
        this.isSearching = false
      } catch (error) {
        this.isSearching = false
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    updateTable () {
      const btn = this.$refs.closeUpdateInventory
      btn.click()
      this.detail.note = this.tempDetail.note
    }
  }
}
</script>
